import App from './App.tsx'
import '@/styles/globals.css'
import { Toaster } from 'sonner'
import { Provider } from 'react-redux'
import { store } from '@/store/store.ts'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from 'posthog-js/react'
import { ImageProvider } from './context/ImageContext.tsx'

const posthogKey = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST

if (!posthogKey) {
  console.error('VITE_REACT_APP_PUBLIC_POSTHOG_KEY is not set')
}

if (!posthogHost) {
  console.error('VITE_REACT_APP_PUBLIC_POSTHOG_HOST is not set')
}

const options = {
  api_host: posthogHost,
  autocapture: false,
}

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <PostHogProvider apiKey={posthogKey} options={options}>
      <ImageProvider>
        <App />
        <Toaster richColors expand position="top-center" theme="dark" />
      </ImageProvider>
    </PostHogProvider>
  </Provider>
)
